// src/store/index.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  // 状态（唯一数据源）
  state: {
    userInfo: {}
  },

  // 计算属性（类似组件的 computed）
  getters: {

  },

  // 同步修改状态（必须是同步函数）
  mutations: {
    $uStore(state, payload) {
      // 判断是否多层级调用，state中为对象存在的情况，诸如user.info.score = 1
      let nameArr = payload.name.split(".");
      let saveKey = "";
      let len = nameArr.length;
      if (nameArr.length >= 2) {
        let obj = state[nameArr[0]];
        for (let i = 1; i < len - 1; i++) {
          obj = obj[nameArr[i]];
        }
        obj[nameArr[len - 1]] = payload.value;
        saveKey = nameArr[0];
      } else {
        // 单层级变量，在state就是一个普通变量的情况
        state[payload.name] = payload.value;
        saveKey = payload.name;
      }
    },

  },

  // 异步操作（可包含任意异步操作，通过 commit 调用 mutation）
  actions: {

  },

  // 模块（拆分复杂状态）
  modules: {
    // 可拆分其他模块，如 user、cart 等
  }
})